import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { ProfileDropdown } from './ProfileDropdown';
import { SearchBar } from './SearchBar';
import { MobileNav } from './MobileNav';
import { Utils } from '@kineticdata/bundle-common';

import logo from '../../assets/images/USDA_logo_xs.png';

const HeaderComponent = props => (
  <>
    {(props.mobile || props.tablet) && (
      <button className="toggle" onClick={props.toggleSidebar}>
        <span className="fa fa-lg fa-bars" />
      </button>
    )}
    {(props.mobile || props.tablet) &&
      props.logo &&
      props.logo !== 'Disabled' && (
        <Link className="logo" to="/">
          <img src={props.logo} alt="USDA Logo" />
        </Link>
      )}

    <div className="mr-auto" aria-hidden="true" />

    {props.profile.validEauthAssuranceLevel && (
      <SearchBar modal={props.mobile || props.tablet} />
    )}
    {!props.mobile && <MobileNav />}
    {props.authenticated && <ProfileDropdown />}
    {!props.authenticated && (
      <Link className="nav-link" to={props.authRoute} title="Sign In">
        <i className="fa fa-fw fa-lg fa-sign-in-alt" />
      </Link>
    )}
  </>
);

export const Header = connect(state => ({
  authenticated: state.app.authenticated,
  authRoute: state.app.authRoute,
  logo: Utils.getAttributeValue(state.app.space, 'Logo', logo),
  alertsDisabled: !Utils.getAttributeValue(state.app.space, 'Alerts Form Slug'),
  profile: state.app.profile,
}))(HeaderComponent);
